<template>
  <Flex
    direction="column"
    justify="center"
    align="center"
    v-test="'migrate-website-success'"
  >
    <BaseStatusIcon state="success" />
    <BaseHeading>
      {{ $t('wavy_onboarding.migrate_website.success.heading') }}
    </BaseHeading>
    <BaseText center>
      {{ $t('wavy_onboarding.migrate_website.success.description') }}
    </BaseText>
  </Flex>
</template>
